import createStore from "view-ui-admin/src/utils/create-store";
import Model from "@/models/admin/distributor-applications";

export default createStore({ Model });
